export default "__VITE_ASSET__RHThAoum__"